<agpr-dialog-container
  [id]="id"
  [heading]="dialogHeader"
  styleClass="agpr-deleteMentionDialog"
  (close)="cancel()"
>
    <div class="agpr-deleteMentionDialog">
        <div
          class="agpr-deleteMentionDialog-Text"
          *ngIf="selectedMentionsFolderNames.length > 0"
        >
            {{ dialogMessage | localize: {count: selectedMentionsFolderNames.length} }}
        </div>
        <agpr-scroll-panel *ngIf="selectedMentionsFolderNames.length > 0">
            <ul class="agpr-deleteMentionDialog-List">
                <li
                  class="agpr-deleteMentionDialog-ListItem"
                  *ngFor="let folderName of selectedMentionsFolderNames"
                >
                    <span class="agpr-deleteMentionDialog-Icon fa fa-circle" aria-hidden="true"></span>
                    <span class="agpr-deleteMentionDialog-FolderName">{{ folderName }}</span>
                </li>
            </ul>
        </agpr-scroll-panel>
        <agpr-message
            *ngIf="hasArchivedCriticalMention"
            [severity]="severity.warning"
        >{{ 'Monitoring.result.deleteMentions.archivedCriticalMentionWarning' | localize }}</agpr-message>
        <agpr-dropdown
            *ngIf="showBurrellesReason"
            [id]="id + '.burrellesDropdown'"
            class="agpr-deleteMentionDialog-burrelles-reason"
            label="Mention.delete.burrelles.reason"
            [options]="burrellesDeletionOptions"
            [(ngModel)]="selectedBurrellesReason"
            (change)="burrellesOptionChange($event)"
        ></agpr-dropdown>
        <agpr-textarea-input
            *ngIf="(
                selectedBurrellesReason?.value === burrellesDeletionEnum.other ||
                selectedBurrellesReason?.value === burrellesDeletionEnum.doesNotMatchInstructions
            )"
            [label]="'Mention.delete.burrelles.reason.' + selectedBurrellesReason.value + '.label'"
            class="agpr-deleteMentionDialog-burrelles-other"
            [(ngModel)]="burrellesReasonOtherText"
            (ngModelChange)="burrellesOtherTextChange($event)"
        ></agpr-textarea-input>
        <span class="agpr-deleteMentionDialog-Text">
            {{ dialogConfirmMsg | localize: { 'count': itemCount } }}
        </span>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            label="Monitoring.result.cancelButtonLabel"
            id="monitoringResult.deleteMentionDialogCancelButton"
            [style]="buttonTypes.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [style]="buttonTypes.primary"
            [disabled]="disableSubmit"
            label="Monitoring.result.deleteMentionsFromAccountButtonLabel"
            id="monitoringResult.deleteMentionsFromAccountButton"
            (click)="deleteFromAccount()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
